import { useMutation } from '@apollo/client'
import { updatePage as updatePageGql }
   from 'src/graphql/mutations/updatePage.gql'

const useUpdatePage = (mutationHookOptions) => {
   const [updatePage, { called, client, data, error, loading }] =
      useMutation(updatePageGql, mutationHookOptions)

   const wrappedMutationFn = (filter, input, mutationFnOptions) => updatePage({
      variables: { ...filter, input },
      ...mutationFnOptions
   })

   return {
      updatePage: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useUpdatePage
